import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Row } from 'react-grid-system';
import classNames from 'classnames/bind';

import styles from './index.module.scss';
import Item from './Item';
import { newMenuListActions } from '../../../../actions';

const cx = classNames.bind(styles);

class List extends Component {
  
  componentDidMount() {
    if (this.props.newMenuList.data.length === 0) {
      this.props.actions.newMenuListActions.request();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { isProcessing, failure } = nextProps.newMenuList;
    return !isProcessing && !failure;
  }

  render() {
    const { newMenuList } = this.props;

    return (
      <div className={cx('container')}>
        <Container>
          <Row>
            {newMenuList.data.map((newMenu, i) => <Item key={String(newMenu.id)} item={newMenu} />)}
          </Row>
        </Container>
      </div>
    );
  }
}


/**
 * Define redux settings
 */
const mapStateToProps = (state) => {
  const { newMenuList } = state;
  return {
    newMenuList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      newMenuListActions: bindActionCreators(newMenuListActions, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(List);
